import moment from 'moment';
import { ProjectTemplateData } from 'data/templates/projects';
import { DateShiftUpdates, List } from 'utils/date-shift';

type TemplateDataUpdate = Required<Pick<ProjectTemplateData, 'id'>> &
  Partial<Pick<ProjectTemplateData, 'duration' | 'startDay'>>;

export const getTemplateDataUpdates = (
  dateShiftUpdates: DateShiftUpdates,
  list: List,
): TemplateDataUpdate[] => {
  const dataUpdates: TemplateDataUpdate[] = [];

  Object.values(dateShiftUpdates).forEach(({ id, startDate, dueDate }) => {
    const update: TemplateDataUpdate = { id };
    const currentEntity = list[id];

    if (startDate) {
      update.startDay = Math.abs(
        moment().startOf('day').diff(moment(startDate), 'day'),
      );
    }
    if (startDate || dueDate) {
      const _startDate = startDate || currentEntity?.startDate;
      const _dueDate = dueDate || currentEntity?.dueDate;

      update.duration = Math.round(
        moment(_dueDate)
          .endOf('day')
          .diff(moment(_startDate).startOf('day'), 'days', true),
      );
    }
    dataUpdates.push(update);
  });

  return dataUpdates;
};
